import { IconFactory } from '@assets';

export const extractDeclarationStatusByIcon = (icon: any): string => {
  const iconToStatusMap = new Map([
    [IconFactory.notSent, 'No anomalies - No risk analysis done'],
    [IconFactory.anomaliesHandled, 'Anomalies detected, all handled by user'],
    [IconFactory.anomaliesHSCodeOrDescription, 'Anomalie(s) detected: HS codes and/or description'],
    [IconFactory.noSentAnomalies, 'No anomalies detected'],
    [IconFactory.anomalyValue, 'Anomalie(s) detected: value'],
  ]);

  return iconToStatusMap.get(icon) || 'Unknown status';
};
